/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PublicationUrl } from './PublicationUrl';
import {
    PublicationUrlFromJSON,
    PublicationUrlFromJSONTyped,
    PublicationUrlToJSON,
    PublicationUrlToJSONTyped,
} from './PublicationUrl';

/**
 * 
 * @export
 * @interface ActivateApiAccessForCurrentRetailerCommand
 */
export interface ActivateApiAccessForCurrentRetailerCommand {
    /**
     * 
     * @type {Set<PublicationUrl>}
     * @memberof ActivateApiAccessForCurrentRetailerCommand
     */
    publicationUrls: Set<PublicationUrl>;
    /**
     * 
     * @type {boolean}
     * @memberof ActivateApiAccessForCurrentRetailerCommand
     */
    generalTermsAccepted: boolean;
}

/**
 * Check if a given object implements the ActivateApiAccessForCurrentRetailerCommand interface.
 */
export function instanceOfActivateApiAccessForCurrentRetailerCommand(value: object): value is ActivateApiAccessForCurrentRetailerCommand {
    if (!('publicationUrls' in value) || value['publicationUrls'] === undefined) return false;
    if (!('generalTermsAccepted' in value) || value['generalTermsAccepted'] === undefined) return false;
    return true;
}

export function ActivateApiAccessForCurrentRetailerCommandFromJSON(json: any): ActivateApiAccessForCurrentRetailerCommand {
    return ActivateApiAccessForCurrentRetailerCommandFromJSONTyped(json, false);
}

export function ActivateApiAccessForCurrentRetailerCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActivateApiAccessForCurrentRetailerCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'publicationUrls': (new Set((json['publicationUrls'] as Array<any>).map(PublicationUrlFromJSON))),
        'generalTermsAccepted': json['generalTermsAccepted'],
    };
}

export function ActivateApiAccessForCurrentRetailerCommandToJSON(json: any): ActivateApiAccessForCurrentRetailerCommand {
    return ActivateApiAccessForCurrentRetailerCommandToJSONTyped(json, false);
}

export function ActivateApiAccessForCurrentRetailerCommandToJSONTyped(value?: ActivateApiAccessForCurrentRetailerCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'publicationUrls': (Array.from(value['publicationUrls'] as Set<any>).map(PublicationUrlToJSON)),
        'generalTermsAccepted': value['generalTermsAccepted'],
    };
}

